export const SubTitleBlock = ({ title }: { title: string }) => {
    return (
        <div className="d-none d-lg-flex justify-content-between align-items-center pt-lg-3 pb-4 pb-lg-5 mb-lg-3">
            <h4 className="fs-base text-light mb-0">{title}</h4>
        </div>
    );
};
